<template>
  <div>
    <sidebar />
    <div class="admin-shell relative md:ml-64 bg-blueGray-100">
      <admin-navbar />
      <header-stats />
      <div class="admin-content-shell px-4 md:px-6 mx-auto w-full">
        <router-view />
        <footer-admin />
      </div>
    </div>
  </div>
</template>
<script>
import AdminNavbar from "@/components/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import HeaderStats from "@/components/Headers/HeaderStats.vue";
import FooterAdmin from "@/components/Footers/FooterAdmin.vue";
export default {
  name: "admin-layout",
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
    FooterAdmin,
  },
};
</script>
